import styles from './LpIntroduction.module.scss'
import { useEffect, useRef } from 'react'
import { gsap, Power4 } from 'gsap'

const LpIntroduction: React.VFC = () => {
  const h1Box = useRef<HTMLDivElement>()
  const pBox = useRef<HTMLParagraphElement>()
  const text = useRef<HTMLDivElement>()
  const timeline = gsap.timeline()

  const tweenVars: gsap.TimelineVars = {
    x: 0,
    duration: 0.5,
    display: 'block',
    width: 500,
    ease: Power4.easeOut,
  }

  useEffect(() => {
    timeline
      .to(text.current, { css: { opacity: 1 } }, 0.5)
      .from(h1Box.current, tweenVars, 0.5)
      .from(pBox.current, tweenVars, 0.6)
  }, [])

  return (
    <>
      <section className={styles.section}>
        <div className={styles.topWrapper}>
          <div className={styles.topImgWrapper}>
            <div className={styles.topImg}></div>
          </div>
          <div className={styles.top}>
            <img className={styles.i3d_logo} src="/img/common/logo_aitria.svg" alt="Aitria" />
            <div className={styles.textWrapper} ref={text}>
              <p className={styles.miniTitle}>UX/UIデザインの力で、ビジネスを成功へ導く</p>
              <h1 className={styles.h1}>
                <div className={styles.h1Box} ref={h1Box}></div>
                共に考え 共に創る
                <br />
                デザインパートナー
              </h1>
              <p className={styles.titleText}>
                <span className={styles.pBox} ref={pBox}></span>
                私たちは徹底したデザイン思考で
                <br />
                アプリやウェブサイトを利用したビジネスを成功へとつなげます。
              </p>
            </div>
            <a className={styles.toContactButton} href="#Contact">
              お問い合わせ
              <span className={styles.mailIcon}></span>
            </a>
          </div>
        </div>
        <div>
          <h2 className={styles.h2}>
            私たちは<span className={styles.redText}>“UX/UIサービス”</span>で<br />
            お客さまのこんな課題を解決します
          </h2>
          <div className={styles.UIUXWrapper}>
            <div className={styles.card}>
              <div className={styles.redBlur}>
                <img className={styles.icon} src="/images/lp2/01_lead/icon_1.png" alt="アイコン１" />
              </div>
              <p className={styles.cardText}>
                新しいサービスの
                <br />
                コンセプトから創りたい
              </p>
            </div>
            <div className={styles.card}>
              <div className={styles.redBlur}>
                <img className={styles.icon} src="/images/lp2/01_lead/icon_2.png" alt="アイコン２" />
              </div>
              <p className={styles.cardText}>
                既存サービスに
                <br />
                新たな価値を加えたい
              </p>
            </div>
            <div className={styles.card}>
              <div className={styles.redBlur}>
                <img className={styles.icon} src="/images/lp2/01_lead/icon_3.png" alt="アイコン３" />
              </div>
              <p className={styles.cardText}>
                サービスを使いやすく
                <br />
                美しく整えたい
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default LpIntroduction
